/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Cat_ContentInputs */

const cs_builder_cat_content = /** @type {(inputs: Builder_Cat_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obsah`)
};

const en_builder_cat_content = /** @type {(inputs: Builder_Cat_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Content`)
};

/**
* | output |
* | --- |
* | "Content" |
*
* @param {Builder_Cat_ContentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_cat_content = /** @type {((inputs?: Builder_Cat_ContentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Cat_ContentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_cat_content(inputs)
	return cs_builder_cat_content(inputs)
});